// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1q6SZ","file":"styles_file__-VNJa"};